import React, { useState, useEffect, useMemo, useContext } from 'react';
import DialogComp from '../../../../Core/Modal/dialogModal';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import AppContext from '../../../../App/AppContext';
import MappingCategoryModal from './mapperCategoryModal';
import { postMappingCategory } from '../../../../Core/Service/ManageAccount/manageAccountService';
import ManageAccountGrid from '../../../managementAccount/manageAccountGrid/index';
import { EditButton } from '../../../../Core/FormInput/inputfields';
import { Grid } from '@material-ui/core';
import ReactDOM from 'react-dom';
import MappingAccountCountModal from './mappingAccountCountModal';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Management Accounts', active: true },
    { name: 'Mapping Categories', active: true }
];
const basecolumns = [
    { field: 'action', title: 'Action', width: 50 },
    { field: 'maMappingCategoryCode', title: 'Code', width: 70 },
    { field: 'maMappingCategoryName', title: 'Description', width: 150 },
    { field: 'accountsMappedCount', title: 'Account Mapped Count', width: 100 },
    { field: 'dashCount', title: 'Dashboards', width: 80 }
];
const MapperCategoryScreen = () => {
    const [state, setState] = useState({
        open: false,
        showLoader: true,
        selectedRowData: {}
    });
    const [modalOpen, setModalOpen] = useState(false);
    const [AccountMappedCode, setAccountMappedCode] = useState(null);
    const { showToast } = useContext(AppContext);

    const pullApiData = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const handleOpenModal = async (rowData) => {
        setAccountMappedCode(rowData.accountsMappedCount);
        setModalOpen(true);
        setState((prev) => ({
            ...prev,
            selectedRowData: rowData
        }));
    };
    const renderEdit = (ev, row) => {
        return (
            <div
                style={{
                    textAlign: 'center'
                }}
            >
                <EditButton
                    toolTipTitle="Update Category"
                    style={{
                        cursor: 'pointer'
                    }}
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            open: true,
                            title: 'Update Category',
                            selectedRowData: row
                        }));
                    }}
                />
            </div>
        );
    };
    const AccMapCountColumnWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                    onClick={() => handleOpenModal(record)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const DashCountWrapper = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center">
                <div
                    title={record.dash}
                    style={
                        {
                            // cursor: 'revert'
                            // fontWeight: 'bold',
                            // textDecoration: 'underline'
                        }
                    }
                    // onClick={() => handleOpenModal(record)}
                >
                    {value}
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.field === 'action');
        if (actionCol) {
            actionCol.renderer = renderEdit;
        }
        let colAccountsMappedCount = tempCols.find((m) => m.field === 'accountsMappedCount');
        if (colAccountsMappedCount.field) {
            colAccountsMappedCount.renderer = AccMapCountColumnWrapper;
        }
        let coldashCount = tempCols.find((m) => m.field === 'dashCount');
        if (coldashCount.field) {
            coldashCount.renderer = DashCountWrapper;
        }
        return tempCols;
    }, []);

    const saveData = async (outData) => {
        let response = await postMappingCategory({
            mAMappingCategoryID: outData.id ?? null,
            mAMappingCategoryCode: outData.code ?? null,
            mAMappingCategoryName: outData.value
        });
        if (response) {
            if (response.success) {
                showToast(response.message || 'updated successfully');
                handleClose();
                pullApiData();
            } else {
                showToast(response.message || 'Something went wrong');
            }
        } else {
            showToast('Something went wrong');
        }
    };
    const addBtnClicked = () => {
        setState((st) => ({
            ...st,
            open: true,
            title: 'Add Category',
            isAdd: true,
            selectedRowData: {}
        }));
    };
    const handleClose = () => {
        setState((st) => ({
            ...st,
            open: false
        }));
    };
    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <ManageAccountGrid
                columns={columns}
                getUrl={`MappingCategory`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
                btnTitle="Add"
                onBtnClick={addBtnClicked}
            />
            {state.open ? (
                <DialogComp open={state.open} onClose={handleClose} title={state.title} maxWidth="md">
                    <MappingCategoryModal data={state} onClose={handleClose} saveData={saveData} />
                </DialogComp>
            ) : null}
            {modalOpen ? (
                <MappingAccountCountModal
                    data={state}
                    onClose={handleCloseModal}
                    saveData={saveData}
                    onSuccess={pullApiData}
                    selectedRowData={state.selectedRowData}
                />
            ) : null}
        </div>
    );
};

export default MapperCategoryScreen;
